import Image from 'react-bootstrap/Image'

function Section6({data}) {
  return (
    <div 
      id="section6" 
      className="mt-scroll scroll-div" 
      data-aos="fade-up" 
      data-aos-duration="2500"
      style={{ backgroundColor: '#f0e7da' }}
    >
      <Image 
        src={"https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/bottom image.webp"} 
        className="w-100"
      />
    </div>
  );
}

export default Section6;